import { render, staticRenderFns } from "./TreatmentItemInputForm.vue?vue&type=template&id=1eb6d8ea&scoped=true&"
import script from "./TreatmentItemInputForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb6d8ea",
  null
  
)

export default component.exports